import {
  Space,
  List,
  Button,
  Input,
  Popup,
  InfiniteScroll,
  SearchBar,
  SpinLoading,
  NavBar,
} from "antd-mobile";
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import debounce from "lodash/debounce";
import { api } from "../common/api";
import { ScanPage } from "./ScanPage";
import { Flex } from "antd";
import { RightOutline, SystemQRcodeOutline } from "antd-mobile-icons";

export const RemoteListPicker = forwardRef(
  (
    {
      fetchList,
      fetchItem,
      placeholder,
      value,
      title,
      onChange,
      labelFn = () => "",
      valueFn = (x) => x.id,
    },
    ref,
  ) => {
    const PAGE_SIZE = 20;
    const [visible, setVisible] = useState(false);
    const scanRef = useRef(null);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [params, setParams] = useState({ hasMore: false, searchValue: null, page: 0 });
    const [hasMore, setHasMore] = useState(false);

    useImperativeHandle(ref, () => ({
      open: () => setVisible(!visible),
      close: () => setVisible(false),
    }));

    useEffect(() => {
      if (visible) {
        fetchList({
          query: params.searchValue,
          page: params.page,
          pageSize: PAGE_SIZE,
        }).then((res) => {
          setHasMore(res.data.length === res.pageSize);
          if (params.page === 0) setData(res.data);
          else setData((old) => [...old, ...res.data]);
        });
      }
    }, [visible, params]);

    const search = debounce((value) => {
      setParams({ page: 0, searchValue: value });
    }, 500);

    useEffect(() => {
      if (!visible) {
        setParams({ hasMore: false, searchValue: null, page: 0 });
        setData([]);
      }
    }, [visible]);

    return (
      <>
        <Popup
          visible={visible}
          onMaskClick={() => {
            setVisible(false);
          }}
          onClose={() => {
            setVisible(false);
          }}
          bodyStyle={{ height: "85vh" }}
        >
          <div style={{ padding: 16 }}>
            <Space direction={"vertical"} style={{ width: "100%" }}>
              <NavBar
                back={null}
                right={
                  <Button
                    onClick={() => {
                      setVisible(false);
                      scanRef.current.open();
                    }}
                  >
                    <SystemQRcodeOutline /> QR Code
                  </Button>
                }
              >
                {title}
              </NavBar>
              <SearchBar onChange={search} placeholder={"Cerca..."} />
              <List style={{ marginTop: 16 }}>
                {data.map((item, index) => (
                  <List.Item
                    arrowIcon
                    clickable
                    key={index}
                    onClick={() => {
                      onChange?.({ label: labelFn(item), value: valueFn(item) });
                      setVisible(false);
                    }}
                  >
                    {labelFn(item)}
                  </List.Item>
                ))}
              </List>
              <InfiniteScroll
                loadMore={() => {
                  setParams((old) => ({ ...old, page: old.page + 1 }));
                }}
                hasMore={hasMore}
              >
                {(hm) => hm && <SpinLoading />}
              </InfiniteScroll>
            </Space>
          </div>
        </Popup>

        <ScanPage
          ref={scanRef}
          onChange={(value) => {
            setLoading(true);
            fetchItem(value)
              .then((emp) => onChange?.({ label: labelFn(emp), value: valueFn(emp) }))
              .finally(() => setLoading(false));
          }}
        />
        <Flex direction={"horizontal"} style={{ width: "100%" }}>
          {value ? (
            <span>{value.label}</span>
          ) : (
            <span style={{ color: "var(--adm-color-light)" }}>{placeholder}</span>
          )}
        </Flex>
        {loading && <SpinLoading />}
      </>
    );
  },
);

export default RemoteListPicker;